module.exports = __webpack_public_path__ + "img/siwa-faq-icon.19c12341.svg";